export const play = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <path d="M26.562 149.027C26.562 80.854 81.827 25.589 150 25.589s123.438 55.265 123.438 123.438S218.173 272.465 150 272.465 26.562 217.2 26.562 149.027Zm189.404-10.091-89.763-65.242A13.32 13.32 0 0 0 105 84.567v130.866a13.32 13.32 0 0 0 21.204 10.873l89.763-65.623a13.32 13.32 0 0 0 0-21.747Z" />
  </svg>
);
